// NetworkContext.js
import { createContext, useContext, useState } from "react";

const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
  const [isOffline, setIsOffline] = useState(false);

  return (
    <NetworkContext.Provider value={{ isOffline, setIsOffline }}>
      {children}
    </NetworkContext.Provider>
  );
};

export const useNetwork = () => useContext(NetworkContext);
